import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StepsService } from '../../../../services/steps.service';
import { IUserIdentificationRequest } from '../../../../classes/unlock-account-authentication';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';

@Component({
	selector: 'restore-with-auth-container',
	template: require('./restore-with-auth-container.component.html'),
})
export class RestoreWithAuthContainerComponent {
	@Input() isBlocked: boolean;
	@Input() identifyRequest: IUserIdentificationRequest;
	@Input() initRequest: IInitializePasswordRequest;
	@Output() EmitIsValidForm = new EventEmitter();
	@Input() needsVerification: boolean;
	@Input() public isLoginBigModalEnabled: boolean = false;

	constructor(public stepsService: StepsService) {}

	isValidForm(event: any): void {
		this.EmitIsValidForm.emit(event);
	}

	checkStep1() {
		if (this.needsVerification && this.stepsService.getCurrentStep === 1) return true;
		else return false;
	}
	checkStep2() {
		if (!this.needsVerification && this.stepsService.getCurrentStep === 1) return true;
		else if (this.needsVerification && this.stepsService.getCurrentStep === 2) return true;
		else return false;
	}
	checkStep3() {
		if (!this.needsVerification && this.stepsService.getCurrentStep === 2) return true;
		else if (this.needsVerification && this.stepsService.getCurrentStep === 3) return true;
		else return false;
	}
	checkStep4() {
		if (!this.needsVerification && this.stepsService.getCurrentStep === 3) return true;
		else if (this.needsVerification && this.stepsService.getCurrentStep === 4) return true;
		else return false;
	}
}
